/**
 * IDs e regras de roteamento da proposta comercial (PDF/PPTX).
 *
 * FONTE ÚNICA: usado por Calculadora Solar e Consulta de Propostas.
 * Não duplique estes IDs nos componentes.
 */

export const EMPRESA_AMAZON_ENERGY_ID = '57c98d2b-fa36-44cb-a500-53bbd6ecf2cc'
export const EMPRESA_CLAREAR_ID = '06a7d62f-cff6-42b7-a651-14896c4e83e4'
export const EMPRESA_LXP_ID = '6563a4d2-828a-4d0f-bce7-964c73a11171'
export const EMPRESA_HANGSIX_ID = 'f0c6de5a-eaf9-4530-a6a7-28140091897d'

export const HORAS_SOL = 5
export const DIAS_MES = 30
export const FATOR_PERDA = 0.8

/** Variação sazonal em torno de HORAS_SOL (média = 1). Norte / Pará. */
export const FATOR_SOL_MENSAL = [0.92, 0.9, 0.94, 0.96, 1, 1.06, 1.12, 1.1, 1.06, 1.02, 0.98, 0.94]

export const isAmazonEnergy = (empresaId) => empresaId === EMPRESA_AMAZON_ENERGY_ID
export const isClarear = (empresaId) => empresaId === EMPRESA_CLAREAR_ID
export const isLxp = (empresaId) => empresaId === EMPRESA_LXP_ID
export const isHangSix = (empresaId) => !empresaId || empresaId === EMPRESA_HANGSIX_ID

/** Clarear e LXP geram PowerPoint; demais empresas geram PDF. */
export const usaFluxoPptx = (empresaId) => isClarear(empresaId) || isLxp(empresaId)

export const formatDateBR = (value) => {
  if (!value) return new Date().toLocaleDateString('pt-BR')
  const d = value instanceof Date ? value : new Date(value)
  if (Number.isNaN(d.getTime())) return String(value)
  return d.toLocaleDateString('pt-BR')
}

export const formatCpfProposta = (cpf) => {
  if (!cpf) return null
  const digits = String(cpf).replace(/\D/g, '')
  if (digits.length !== 11) return cpf
  return digits.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4')
}

export const slugNomeArquivo = (nome) =>
  String(nome || 'cliente').trim().replace(/\s+/g, '_') || 'cliente'

export const estimarKwhPorKwp = (kwp) =>
  Math.round((Number(kwp) || 0) * HORAS_SOL * DIAS_MES * FATOR_PERDA)

/** Geração mensal (kWh): kWp × HSP do mês × 30 dias × 0,8. Média = estimarKwhPorKwp. */
export const estimarGeracaoMensalKwh = (kwp) => {
  const base = estimarKwhPorKwp(kwp)
  return FATOR_SOL_MENSAL.map((fator) => Math.round(base * fator))
}

export const getBase64FromUrl = async (url) => {
  try {
    const response = await fetch(url)
    const blob = await response.blob()
    return new Promise((resolve, reject) => {
      const reader = new FileReader()
      reader.onloadend = () => resolve(reader.result)
      reader.onerror = reject
      reader.readAsDataURL(blob)
    })
  } catch (error) {
    console.warn('Erro ao converter imagem:', error)
    return null
  }
}
